import { render, staticRenderFns } from "./company-profile.vue?vue&type=template&id=03557962&scoped=true"
import script from "./company-profile.vue?vue&type=script&lang=js"
export * from "./company-profile.vue?vue&type=script&lang=js"
import style0 from "./company-profile.vue?vue&type=style&index=0&id=03557962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03557962",
  null
  
)

export default component.exports